export default {
    // page 4 Jenis olahraga
    sportType: (value) => {
        return value.map((item) => `- ${item.type}, ${item.duration}`)
            .join("\n");
    }
}